import { handleActions } from 'redux-actions';

import { PresenceQueryParams } from 'hocs/presence/api/presence';

import { presenceActions } from '../../presence/actions/presenceActions';
import { teamActions } from '../actions/teamPage';

const { selectTeamMembersFilter, teamToggleAgentDetails, setPresenceFilters } =
  teamActions;

const { presenceGetAllSucceeded } = presenceActions;

type TeamAgentT = {
  isOpen: boolean;
  shown: boolean;
  id: string;
};

export type TeamAgentsType = {
  ui: {
    filter: string;
  };
  teamAgents: Array<TeamAgentT>;
  agentsDetail: { [key: string]: boolean };
  presenceFilters: PresenceQueryParams;
};

export const initialState: TeamAgentsType = {
  ui: {
    filter: 'online',
  },
  teamAgents: [],
  agentsDetail: {},
  presenceFilters: {},
};

const team = handleActions<TeamAgentsType, any>(
  {
    [selectTeamMembersFilter.toString()]: (
      state: TeamAgentsType,
      action: any,
    ) => {
      return {
        ...state,
        ui: {
          ...state.ui,
          filter: action.payload.filter,
        },
      };
    },

    [presenceGetAllSucceeded.toString()]: (
      state: TeamAgentsType,
      action: any,
    ) => {
      const teamAgents: any[] = [];
      action.payload.data.forEach((userPresence) =>
        teamAgents.push({ id: userPresence.user.id, isOpen: false }),
      );
      return {
        ...state,
        teamAgents,
      };
    },
    [teamToggleAgentDetails.toString()]: (
      state: TeamAgentsType,
      action: any,
    ) => {
      const { id } = action.payload;
      return {
        ...state,
        agentsDetail: {
          ...state.agentsDetail,
          [id.toString()]: !state.agentsDetail[id],
        },
      };
    },
    [setPresenceFilters.toString()]: (state: TeamAgentsType, action: any) => {
      return {
        ...state,
        presenceFilters: action.payload,
      };
    },
  },

  initialState,
);

export default team;
